import { Box, Divider, Typography } from '@mui/material';
import React from 'react';
import { IProps } from 'types/common';

type ISettingsSectionProps = IProps & {
	divider?: boolean;
	title?: string;
};

const SettingsSection: React.FC<ISettingsSectionProps> = ({
	children,
	title,
	divider
}) => (
	<Box display="flex" flexDirection="column" pt={2}>
		{title && (
			<Typography pb={3} variant="h6">
				{title}
			</Typography>
		)}
		{children}
		{divider ? (
			<Box pt={6}>
				<Divider />
			</Box>
		) : null}
	</Box>
);

SettingsSection.defaultProps = {
	title: '',
	divider: false
};

export default SettingsSection;
